import { cn } from '@commenda/utils';
import React from 'react';

interface ICheckboxInput extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  checked: boolean;
  onCheck: React.Dispatch<React.SetStateAction<boolean>>;
  id: string;
  _css?: string;
}

const CheckboxInput = ({
  label,
  checked,
  onCheck,
  id,
  _css = '',
  ...restProps
}: ICheckboxInput) => {
  return (
    <div className={cn('flex py-4 gap-3 items-center', _css)}>
      <input
        type="checkbox"
        className="w-4 h-4 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500 cursor-pointer"
        aria-describedby={label}
        checked={checked}
        onChange={(e) => onCheck(e.target.checked)}
        id={id}
        {...restProps}
      />
      <label htmlFor={id} className="text-sm text-gray-500">
        {label}
      </label>
    </div>
  );
};

export default CheckboxInput;
